import React from 'react'
import { useTranslation } from 'react-i18next'
import { InsightContentSettingType } from 'components/insightContent/types'
import { useMeasureWithSentimentCount } from 'components/insightContent/hooks'
import { getPercentOfTotal } from 'components/insightContent/utils/utils'
import { PercentDisplay } from 'components/insightContent/visualization/Overview'
import { CountTypeStrings } from 'enums/CountType'

import SingleMeasure from '../SingleMeasure'
import Title from './Title'

const NameMeasureWithShareOfSentiment = ({
  detailSetting,
  countType
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
}) => {
  const { t } = useTranslation()
  const measureWithSentimentCount = useMeasureWithSentimentCount()

  const customizedInfoDisplay = (value: number, displayedCount: string) => {
    const sentimentPercent = getPercentOfTotal(value, measureWithSentimentCount)

    return (
      <PercentDisplay
        count={displayedCount}
        sideLabel={
          sentimentPercent &&
          t('percentOfSentiment', {
            sentimentPercent,
            interpolation: { escapeValue: false }
          })
        }
      />
    )
  }

  return (
    <SingleMeasure
      detailSetting={detailSetting}
      countType={countType}
      customizedInfoDisplay={customizedInfoDisplay}>
      <Title countType={countType} selectionName={detailSetting.selectionName} />
    </SingleMeasure>
  )
}

export default NameMeasureWithShareOfSentiment
